import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import type { VTooltip } from 'vuetify/components';
type Location = VTooltip['$props']['location'];


export default /*@__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: {
    text: { type: [String, Number], required: true },
    maxWidth: { type: Number, required: false },
    location: { type: null, required: false, default: 'top' },
    autoDisable: { type: Boolean, required: false, default: false },
    disabled: { type: Boolean, required: false, default: false }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const hasTextTruncate = ref(false);
const tooltipRef = ref();

const resizeObserver = new ResizeObserver((entries) => {
  const element = entries?.[0]?.target;
  const contentWidth = element?.scrollWidth;
  const containerWidth = element?.clientWidth;
  hasTextTruncate.value = contentWidth > containerWidth;
});

watch(
  () => tooltipRef.value?.activatorEl,
  (element) => {
    if (element && props.autoDisable) {
      resizeObserver.observe(element);
    }
  },
);

const disabledTooltip = computed(() => {
  if (props.disabled) {
    return true;
  }
  return props.autoDisable && !hasTextTruncate.value;
});

const __returned__ = { props, hasTextTruncate, tooltipRef, resizeObserver, disabledTooltip }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})